import card1Go from '@p2p/assets/img/card-1go.png';
import cardBlackImg from '@p2p/assets/img/card-black.png';
import cardDrip from '@p2p/assets/img/card-drip.png';
import cardGray from '@p2p/assets/img/card-gray.png';
import cardImg from '@p2p/assets/img/card-icon.png';
import cardIzzi from '@p2p/assets/img/card-izzi.png';
import cardMonro from '@p2p/assets/img/card-monro.png';
import cardRedImg from '@p2p/assets/img/card-red.png';
import {
  RequestDripIcon,
  RequestFreshIcon,
  RequestIcon,
  RequestLegzoIcon,
  RequestMonroIcon,
  RequestStardaIcon,
} from '@p2p/assets/svg';
import { addZero, formatNumberWithSpaces } from '@p2p/shared/functions';
import { useMemo } from 'react';

import styles from './TransferCard.module.scss';

type PaymentCardProps = {
  isShowStatus?: boolean;
  time: number;
  price: number;
  code: string;
  status: string;
};

export const TransferCard = ({ isShowStatus, time, price, code, status }: PaymentCardProps) => {
  const formatTime = useMemo(
    () => `${addZero(Math.floor(time / 60))}:${addZero(time % 60)}`,
    [time],
  );
  const img = useMemo(() => {
    switch (status) {
      case 'sol':
        return cardBlackImg;
      case 'fresh':
        return cardBlackImg;
      case 'starda':
        return cardRedImg;
      case 'jet':
        return cardGray;
      case 'drip':
        return cardDrip;
      case 'izzi':
        return cardIzzi;
      case 'onego':
        return card1Go;
      case 'monro':
        return cardMonro;
      default:
        return cardImg;
    }
  }, [status]);

  const requestImg = useMemo(() => {
    switch (status) {
      case 'sol':
        return <RequestIcon />;
      case 'starda':
        return <RequestStardaIcon />;
      case 'izzi':
        return <RequestStardaIcon />;
      case 'jet':
        return <RequestIcon />;
      case 'drip':
        return <RequestDripIcon />;
      case 'legzo':
        return <RequestLegzoIcon />;
      case 'fresh':
        return <RequestFreshIcon />;
      case 'monro':
        return <RequestMonroIcon />;
      default:
        return <RequestIcon />;
    }
  }, [status]);

  return (
    <div className={styles[status]}>
      <div className={styles.payment_dialog__card}>
        <div className={styles.payment_dialog__card_top}>
          <div className={styles.payment_dialog__card_name}>
            <img src={img} alt="" />
            <span>{status === 'onego' ? '1GO' : status}.casino</span>
          </div>
          {time > 0 && <div className={styles.payment_dialog__card_time}>{formatTime}</div>}
        </div>
        <div className={styles.payment_dialog__card_balance}>
          {formatNumberWithSpaces(price)} {code}
        </div>
        <div className={styles.payment_dialog__card_bottom}>
          <div className={styles.payment_dialog__card_commission}>Без комиссии</div>
          {isShowStatus && (
            <div className={styles.payment_dialog__card_status}>
              {requestImg}
              <span>Заявка активна</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
